module.exports = __webpack_public_path__ + "static/media/menu2.e6033dc3.png";